module.exports = __webpack_public_path__ + "static/media/icon-scheduling-month.4300d6d1.svg";